(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
      document.addEventListener('DOMContentLoaded', function () {
        const marqueeRow = document.querySelector('.announcement-marquee-row');
        if (!marqueeRow) return;
        const blocks = Array.from(marqueeRow.children);
        if (blocks.length === 0) return;
        const containerWidth = marqueeRow.offsetWidth;
        const blocksWidth = blocks.reduce((sum, el) => sum + el.offsetWidth, 0);
        let repeat = 1;
        while (blocksWidth * (repeat + 1) + blocks.length * repeat < containerWidth) {
          repeat++;
        }
        if (repeat > 1) {
          repeat--;
        }
        for (let i = 1; i < repeat; i++) {
          blocks.forEach((block) => {
            marqueeRow.appendChild(block.cloneNode(true));
          });
        }
        const lastMsg = marqueeRow.querySelector('.announcement-bar__message:last-child');
        if (lastMsg && lastMsg.textContent.trim().length === 1) {
          lastMsg.remove();
        }
        marqueeRow.style.display = 'flex';
        marqueeRow.style.gap = '0';
        marqueeRow.style.justifyContent = 'space-around';
        marqueeRow.style.alignItems = 'center';
        const marquee = marqueeRow.closest('.announcement-marquee');
        if (marquee) marquee.style.opacity = '1';
      });
    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop >= 10) {
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('[data-mega-slider]').forEach(function(slider) {
      const track = slider.querySelector('.mega-menu-slider__track');
      const slides = slider.querySelectorAll('.mega-menu-slider__slide');
      const prevBtn = slider.querySelector('[data-mega-slider-prev]');
      const nextBtn = slider.querySelector('[data-mega-slider-next]');
      let currentIndex = 0;
      const totalSlides = slides.length;

        function updateSlider() {
          const slideWidth = slides[0].offsetWidth + 24; 
          track.style.transform = 'translateX(-' + (currentIndex * slideWidth) + 'px)';
          slides.forEach((slide, idx) => {
            slide.classList.toggle('mega-menu-slider__slide--active', idx === currentIndex);
          });
          prevBtn.disabled = currentIndex === 0;
          nextBtn.disabled = currentIndex >= totalSlides - 1;
        }

        prevBtn.addEventListener('click', function() {
          if (currentIndex > 0) {
            currentIndex--;
            updateSlider();
          }
        });

        nextBtn.addEventListener('click', function() {
          if (currentIndex < totalSlides - 1) {
            currentIndex++;
            updateSlider();
          }
        });

        window.addEventListener('resize', updateSlider);
        updateSlider();
    });

    const megaMenuItems = document.querySelectorAll('.have-megamenu');
    megaMenuItems.forEach(function(item) {
      let closeTimeout;
      const DELAY = 500;
      let isHovering = false;

      function keepMenuOpen() {
        isHovering = true;
        if (closeTimeout) {
          clearTimeout(closeTimeout);
          closeTimeout = null;
        }
        item.classList.add('mega-menu-keep-open');
      }

      function scheduleClose() {
        isHovering = false;
        if (closeTimeout) {
          clearTimeout(closeTimeout);
        }
        closeTimeout = setTimeout(function() {
          if (!isHovering) {
            item.classList.remove('mega-menu-keep-open');
          }
          closeTimeout = null;
        }, DELAY);
      }

      item.addEventListener('mouseenter', keepMenuOpen);
      item.addEventListener('mouseleave', function(e) {
        const megaMenu = item.querySelector('.header-mega-menu');
        setTimeout(function() {
          if (megaMenu && !megaMenu.matches(':hover') && !item.matches(':hover')) {
            scheduleClose();
          }
        }, 50);
      });

      const megaMenu = item.querySelector('.header-mega-menu');
      if (megaMenu) {
        megaMenu.addEventListener('mouseenter', keepMenuOpen);
        megaMenu.addEventListener('mouseleave', function(e) {
          setTimeout(function() {
            if (!megaMenu.matches(':hover') && !item.matches(':hover')) {
              scheduleClose();
            }
          }, 50);
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
